import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { useAIFeatureEnableManager } from '@/src/hooks/AIFeatureEnableManager'
import { DeviceType } from '@/src/types/deviceType'
import { Card } from '@mui/material'
import { useTranslations } from 'next-intl'
import { AIFilterSidebar } from '../aiFilter'
import AirlinesFilterWrapperSideBar from './airlinesFilterSideBar'
import ArrivalTimingsFilterWrapper from './arrivalTimings'
import FilterHeaderWrapper from './filterHeader'
import FlightTimingsFilterWrapper from './flightTimings'
import IncludeAirportsFilterWrapper from './includeAirportsFilter'
import PriceRangeFilterWrapper from './priceRangeFilter'
import RecommendedFilterWrapper from './recomendedFilter'
import StopsFilterWrapper from './stops'
interface FiltersWrapperProps {
    deviceType: DeviceType
}

const FiltersWrapper = ({ deviceType }: FiltersWrapperProps) => {
    const tHeader = useTranslations('header')
    const tCommon = useTranslations('common')
    const { srpSmartFilterSort } = useAIFeatureEnableManager()

    return (
        <Card
            sx={{
                bgcolor: 'background.default',
                borderRadius: 1.5,
                border: deviceType === 'DESKTOP' ? 1 : 0,
                borderColor: 'grey.200',
                overflow: 'auto',
                boxShadow: 'none',
                // Hide scrollbar while maintaining scroll functionality
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}
        >
            <ErrorBoundaryWrapper identifier={`filterHeader-${deviceType}-srp`} fallback={null}>
                <FilterHeaderWrapper tHeader={tHeader} tCommon={tCommon} deviceType={deviceType} />
            </ErrorBoundaryWrapper>

            {/* AI Filter */}
            {srpSmartFilterSort && (
                <ErrorBoundaryWrapper identifier={`aiFilter-${deviceType}-srp`} fallback={null}>
                    <AIFilterSidebar />
                </ErrorBoundaryWrapper>
            )}

            {/* Recommended Filter */}
            <ErrorBoundaryWrapper identifier={`recommendedFilter-${deviceType}-srp`} fallback={null}>
                <RecommendedFilterWrapper />
            </ErrorBoundaryWrapper>

            {/* Stops Filter */}
            <ErrorBoundaryWrapper identifier={`stopsFilter-${deviceType}-srp`} fallback={null}>
                <StopsFilterWrapper />
            </ErrorBoundaryWrapper>

            {/* Departure Flight Timings Filter */}
            <ErrorBoundaryWrapper identifier={`flightTimingsFilter-${deviceType}-srp`} fallback={null}>
                <FlightTimingsFilterWrapper />
            </ErrorBoundaryWrapper>

            {/* Arrival Flight Timings Filter */}
            <ErrorBoundaryWrapper identifier={`arrivalTimingsFilter-${deviceType}-srp`} fallback={null}>
                <ArrivalTimingsFilterWrapper />
            </ErrorBoundaryWrapper>

            {/* Airlines Filter */}
            <ErrorBoundaryWrapper identifier={`airlinesFilter-${deviceType}-srp`} fallback={null}>
                <AirlinesFilterWrapperSideBar deviceType={deviceType} />
            </ErrorBoundaryWrapper>

            {/* Price Range Filter */}
            <ErrorBoundaryWrapper identifier={`priceRangeFilter-${deviceType}-srp`} fallback={null}>
                <PriceRangeFilterWrapper />
            </ErrorBoundaryWrapper>

            {/* Trip Duration Filter */}
            {/* <ErrorBoundaryWrapper identifier={`tripDurationFilter-${deviceType}-srp`} fallback={null}>
                <TripDurationFilterWrapper />
            </ErrorBoundaryWrapper> */}

            {/* Layover Duration Filter */}
            {/* <ErrorBoundaryWrapper identifier={`layoverDurationFilter-${deviceType}-srp`} fallback={null}>
                <LayoverDurationFilterWrapper />
            </ErrorBoundaryWrapper> */}

            {/* Layover Airport Filter */}
            {/* <ErrorBoundaryWrapper identifier={`layoverAirportFilter-${deviceType}-srp`} fallback={null}>
                <LayoverAirportFilterWrapper />
            </ErrorBoundaryWrapper> */}

            {/* Include Airports Filter */}
            <ErrorBoundaryWrapper identifier={`includeAirportsFilter-${deviceType}-srp`} fallback={null}>
                <IncludeAirportsFilterWrapper />
            </ErrorBoundaryWrapper>
        </Card>
    )
}

export default FiltersWrapper
